import { CircularProgressProps } from '@mui/material';

export const circularProgressPropsBase: CircularProgressProps = {
  variant: 'indeterminate',
  size: '3.5em',
  thickness: 3.6,
};
